import styled from 'styled-components';

export const Container = styled.div`
  width: 90%;
  max-width: 1024px;
  margin: 40px auto;
`;
